var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CommunicationsEvent, ContainerCommunicationHandler, CommunicationsEventKind } from '../communications/index';
import { getHashCode } from '../../../utilities/getHashCode';
/**
 * @inheritdoc
 */
var CrossWindowContainerCommunicationHandler = /** @class */ (function (_super) {
    __extends(CrossWindowContainerCommunicationHandler, _super);
    /**
     * Constructor.
     *
     * @param communicationsManager A communications manager.
     * @param embedId The Id of the embedded element.
     * @param containerMethods The methods to communicate with the container.
     */
    function CrossWindowContainerCommunicationHandler(communicationsManager, embedId, containerMethods) {
        var _this = _super.call(this, communicationsManager, containerMethods) || this;
        _this.embedId = embedId;
        return _this;
    }
    /**
     * @inheritdoc
     */
    CrossWindowContainerCommunicationHandler.prototype.handleEventCore = function (e) {
        if (!this.embedId)
            return;
        if (!e.contentId && e.kind === CommunicationsEventKind.Mounted) {
            this.attemptHandShake(e);
            return;
        }
        if (this.embedId !== e.contentId)
            return;
        _super.prototype.handleEventCore.call(this, e);
    };
    /**
     * Attempt a handshake with the content.
     */
    CrossWindowContainerCommunicationHandler.prototype.attemptHandShake = function (e) {
        var hash = getHashCode(this.embedId).toString(10);
        var response = new CommunicationsEvent(CommunicationsEventKind.Mounted);
        // We got a message back so if the data matches the hash we sent send the id
        if (e.data && e.data === hash) {
            response.contentId = this.embedId;
        }
        else {
            response.data = hash;
        }
        this.send(response);
    };
    return CrossWindowContainerCommunicationHandler;
}(ContainerCommunicationHandler));
export { CrossWindowContainerCommunicationHandler };
//# sourceMappingURL=containerCommunicationHandler.js.map